<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 常见问题类型
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <el-header>
          <el-button class="filter-item" type="success"  @click="handleCreate">新增</el-button>
        </el-header>
        <el-main>
          <el-table border v-loading="listLoading" :data="tableData" style="width: 100%">
            <el-table-column prop="id" label="ID" />
            <el-table-column prop="type_name" label="类型名称"/>
            <el-table-column prop="sort_number" label="展示顺序" />
            <el-table-column label="操作" >
              <template slot-scope="scope">
                <el-button size="mini" @click="edit(scope.row)" type="primary" icon="el-icon-edit">编辑</el-button>
                <el-button size="mini" @click="del(scope.row)" type="danger" icon="el-icon-delete">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <pagination
            v-show="total>0"
            :total="total"
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            @pagination="handleList"
          />

          <el-dialog title="新增问题类型" width="450px"  center :visible.sync="addDialog" :close-on-click-modal= "false" @close='closeDialog'>
            <el-form :model="addData">
              <el-form-item label="类型名称" :label-width="formLabelWidth">
                <el-input v-model="addData.type_name"   style="width:216px"></el-input>
              </el-form-item>
              <el-form-item label="展示顺序" :label-width="formLabelWidth">
                <el-input-number v-model="addData.sort_number" :min="1"></el-input-number>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="removeAdd">取 消</el-button>
              <el-button type="primary" @click="sureAdd">确 定</el-button>
            </div>
          </el-dialog>

          <el-dialog title="编辑问题类型" width="450px"  center :visible.sync="editDialog">
            <el-form :model="editData">
              <el-form-item label="类型名称" :label-width="formLabelWidth">
                <el-input v-model="editData.type_name"   style="width:216px"></el-input>
              </el-form-item>
              <el-form-item label="展示顺序" :label-width="formLabelWidth">
                <el-input-number v-model="editData.sort_number" :min="1"></el-input-number>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="removeEdit">取 消</el-button>
              <el-button type="primary" @click="sureEdit">确 定</el-button>
            </div>
          </el-dialog>
        </el-main>
      </div>
    </div>
  </div>
</template>

<script>
import {
  commonQuestionType,
  addCommonQuestionType,
  delCommonQuestionType,
  commitCommonQuestionType
} from "@/api/work_question";
import Pagination from "@/components/pagination/index";

export default {
  components: { Pagination },
  name: "work_question_type",
  data() {
    return {
      listLoading: false,
      total: 0,
      tableData: [],
      listQuery: {
        page: 1,
        limit: 10
      },
      addData: {
        type_name: undefined,
        sort_number: undefined
      },
     // 添加数据的缓存。
        keepAddData:{},
        addCheck:0,

      addDialog: false,
      formLabelWidth: "120px",
      editDialog: false,
      editData: {
        type_name: undefined,
        sort_number: undefined,
        id: undefined
      }
    };
  },
  created() {
    this.handleList();
  },
  methods: {
    handleCreate() {
      this.addData.type_name = undefined;
      this.addData.sort_number = undefined;
      if(this.addCheck == 1){
          this.addData = JSON.parse(JSON.stringify(this.keepAddData));
      }
      this.addDialog = true;
    },
    async handleList() {
      this.listLoading = true;
      const r = await commonQuestionType(this.listQuery);
      if (r.data.code !== 200) return;
      this.tableData = r.data.data.data;
      this.total = r.data.data.total;
      this.listLoading = false;
    },
    removeAdd() {
      this.addDialog = false;
    },
    async sureAdd() {
      addCommonQuestionType(this.addData)
       .then(response =>{
           if(response.data.code == 200){
                this.$message.success(response.data.message);
                this.addCheck = 2;
                this.addDialog = false;
                this.handleList();
             }else{
                this.$message.error(response.data.message);
          }
       })
       .catch(error =>{
         this.addDialog = false;
       })
    },
     closeDialog(){
        if(this.addCheck == 0 || this.addCheck == 1){
           this.keepAddData = JSON.parse(JSON.stringify(this.addData));
             this.addCheck = 1;
        }
        if( this.addCheck == 2){
             this.addCheck = 0;
             this.keepAddData = {};
        }
      },
    edit(row) {
      this.editData.type_name = row.type_name;
      this.editData.sort_number = row.sort_number;
      this.editData.id = row.id;
      this.editDialog = true;
    },
    async del(row) {
      const r = await delCommonQuestionType(row.id);
      if (r.data.code !== 200) return;
      await this.handleList();
    },
    removeEdit() {
      this.editDialog = false;
      this.editData.type_name = undefined;
      this.editData.sort_number = undefined;
      this.editData.id = undefined;
    },
    async sureEdit() {
      const r = await commitCommonQuestionType(this.editData);
      this.editDialog = false;
      if (r.data.code !== 200) return;
      await this.handleList();
    }
  }
};
</script>

<style>
.title {
  font-size: 14px;
  color: #606266;
  margin-bottom: 20px;
}
</style>